import React from "react";
import "./style.scss";

export const RenderInputError = ({ messages = [] }) => {
  return (
    <ul className="error-info">
      {messages.includes("min") && (
        <li className="elabel">
          Password should be at least 8 characters long
        </li>
      )}
      {messages.length >= 1 && !messages.includes("min") && (
        <li className="elabel">
          With at least one uppercase, one lowercase, one number and one special
          character. Valid special characters are +,-,#,@
        </li>
      )}
    </ul>
  );
};

export const RenderInputErrorOther = ({ messages = [] }) => {
  return (
    <ul className="error-info">
      {messages.map((msg) => (
        <li key={`${Math.random()}`} className="elabel">
          {msg}
        </li>
      ))}
    </ul>
  );
};
